<svelte:head>

    <title>Keywords • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Keywords from "../components/keywords.svelte";

</script>

<SessionManager />

<section>

    <Keywords/>

</section>

<style>

    section {
        height: inherit;
    }

</style>
